<template>
  <div class="home-page">
    <my-header class="fixed-header"></my-header>
    <!-- 头部横幅大图 -->
    <section class="banner"></section>
    <!-- 公司介绍标题 -->
    <section class="intro-title">
      <span>公司介绍</span>
    </section>

    <!-- 公司介绍主体区域 -->
    <section class="company-intro">
      <div class="intro-text-wrap">
        <div class="huijiao_title">石家庄慧教云创科技有限公司</div>
        <div class="sub-desc">
          <span>致力于继续教育、终身教育</span>
          <span style="margin-left: 26px">成为学习型社会的领军企业</span>
        </div>
        <!-- 三栏文字模块 -->
        <div class="intro-list">
          <div class="intro-item">
            <div style="width: 350px;display: flex;justify-content: center">
              <div class="item-icon"></div>
            </div>
            <p>石家庄慧教云创科技有限公司（以下简称“公司”），是2026年成立于河北石家庄的创新型科技企业，专注深耕智慧继续教育与职业终身教育赛道，专注打造本地化在线教育数字化运营服务体系。</p>
          </div>
          <div class="intro-item">
            <div style="width: 350px;display: flex;justify-content: center">
              <div class="item-icon data-icon"></div>
            </div>
            <p>公司核心团队由拥有多年在线教育平台研发、院校教务运营、课程资源开发经验的行业人才组建，聚焦省内高校继续教育学院、职业院校、社会培训机构数字化转型需求，自主研发在线教育教务教学管理云平台——“慧教云创在线”，平台在传统SaaS模式基础上创新打造OMS运营服务体系，打通信息化建设、课程供给、数据运维、全程运营全链条服务，一站式解决院校线上办学、学员学习管理、教务流程数字化等核心痛点。</p>
          </div>
          <div class="intro-item">
            <div style="width: 350px;display: flex;justify-content: center">
              <div class="item-icon location-icon"></div>
            </div>
            <p>立足河北，辐射华北，公司紧跟全民终身学习发展战略，以轻量化、高适配、本地化服务为核心优势，致力于为区域院校提供高性价比、落地性强的在线教育数字化解决方案，立志成长为华北地区继续教育、职业教育数字化领域的优质服务商，助力构建人人可学、时时可学的学习型社会。</p>
          </div>
        </div>
      </div>
      <!-- 右侧建筑背景图由css背景承载 -->
    </section>

    <!-- 底部footer -->
    <my-footer></my-footer>
  </div>
</template>

<script>
  import MyFooter from "../components/myFooter";
  import MyHeader from "../components/myHeader";
  export default {
    name: "home",
    components: {MyHeader, MyFooter },
    data() {
      return {

      };
    },
    mounted() {},
    methods: {

    }
  };
</script>

<style scoped>
  /* 导航悬浮样式 */
  .fixed-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999; /* 层级最高，盖住banner */
  }
  /* 全局重置 */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .home-page {
    width: 100%;
  }
  /* 顶部横幅banner */
  .banner {
    width: 100%;
    height: 560px;
    background: #b0daf8 url("~@/../static/assets/index_banner.png") no-repeat center / cover;
    margin-top: -70px;
  }

  /* 公司介绍标题 */
  .intro-title {
    width: 100%;
    text-align: center;
    padding: 44px 0 16px;
  }
  .intro-title span {
    font-size: 34px;
    color: #4A4E65;
    font-weight: bold;
  }

  /* 公司介绍主体容器 */
  .company-intro {
    width: 100%;
    height: 583px;
    padding: 0px 360px;
    /* 右侧建筑大图背景 */
    background: #eef6fe url("~@/../static/assets/index_intro.png") no-repeat right center / contain;
    overflow: hidden;
  }
  .huijiao_title{
    font-size: 32px;
    font-weight: bold;
    color: #4A4E65;
    margin-top: 116px;
  }
  .sub-desc {
    font-size: 16px;
    color: #4A4E65;
    margin-bottom: 96px;
    margin-top: 29px;
  }

  /* 三栏文字布局 */
  .intro-list {
    display: flex;
    gap: 70px;
  }
  .intro-item {
    flex: 1;
  }
  /* 三种不同图标样式，匹配设计里的图标 */
  .item-icon {
    width: 48px;
    height: 48px;
    margin-bottom: 18px;
    background: url("~@/../static/assets/company_icon.png") no-repeat center / contain;
  }
  .item-icon.data-icon {
    background: url("~@/../static/assets/team_icon.png") no-repeat center / contain;
  }
  .item-icon.location-icon {
    background: url("~@/../static/assets/location_icon.png") no-repeat center / contain;
  }
  .intro-item p {
    width: 350px;
    font-size: 14px;
    color: #4A4E65;
    line-height: 1.7;
    text-align: justify;
  }
</style>



// WEBPACK FOOTER //
// src/view/home.vue